'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _EllipsisOutlined = _interopRequireDefault(require('./lib/icons/EllipsisOutlined'));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

var _default = _EllipsisOutlined;
exports.default = _default;
module.exports = _default;